import React from 'react'

export const NextIcon = ({ color = 'white', hoverColor = 'white' }) => (
  <svg
    width="26px"
    height="26px"
    viewBox="0 0 26 26"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    className={`fill-current text-${color} hover:text-${hoverColor}`}
  >
    <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
      <circle
        stroke="#F0F0F0"
        fill="currentColor"
        opacity="0.6"
        cx="13"
        cy="13"
        r="12.5"
      />
      <g
        transform="translate(5.500000, 5.000000)"
        fill="#333333"
        fillRule="nonzero"
      >
        <path
          d="M14.1608599,4.63259828 L14.8391401,5.36740172 C15.0264419,5.57031209 15.0137887,5.88664162 14.8108784,6.0739435 L8.32528065,12.0606491 C8.12808293,12.2426778 7.82235202,12.2365656 7.6325872,12.0468008 L1.64644661,6.06066017 C1.45118446,5.86539803 1.45118446,5.54881554 1.64644661,5.35355339 L2.35355339,4.64644661 C2.54881554,4.45118446 2.86539803,4.45118446 3.06066017,4.64644661 L7.68802483,9.27381126 C7.87778964,9.46357608 8.18352056,9.46968826 8.38071827,9.2876596 L13.4543182,4.60433661 C13.6572285,4.41703473 13.9735581,4.42968791 14.1608599,4.63259828 Z"
          transform="translate(8.235587, 8.325846) rotate(-90.000000) translate(-8.235587, -8.325846) "
        />
      </g>
    </g>
  </svg>
)

export const PreviousIcon = ({ color = 'white', hoverColor = 'white' }) => (
  <svg
    width="26px"
    height="26px"
    viewBox="0 0 26 26"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    className={`fill-current text-${color} hover:text-${hoverColor}`}
  >
    <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
      <g>
        <circle
          stroke="#F0F0F0"
          fill="currentColor"
          opacity="0.6"
          cx="13"
          cy="13"
          r="12.5"
        />
        <g
          transform="translate(12.500000, 13.000000) scale(-1, 1) translate(-12.500000, -13.000000) translate(4.500000, 5.000000)"
          fill="#333333"
          fillRule="nonzero"
        >
          <path
            d="M14.1608599,4.63259828 L14.8391401,5.36740172 C15.0264419,5.57031209 15.0137887,5.88664162 14.8108784,6.0739435 L8.32528065,12.0606491 C8.12808293,12.2426778 7.82235202,12.2365656 7.6325872,12.0468008 L1.64644661,6.06066017 C1.45118446,5.86539803 1.45118446,5.54881554 1.64644661,5.35355339 L2.35355339,4.64644661 C2.54881554,4.45118446 2.86539803,4.45118446 3.06066017,4.64644661 L7.68802483,9.27381126 C7.87778964,9.46357608 8.18352056,9.46968826 8.38071827,9.2876596 L13.4543182,4.60433661 C13.6572285,4.41703473 13.9735581,4.42968791 14.1608599,4.63259828 Z"
            transform="translate(8.235587, 8.325846) rotate(-90.000000) translate(-8.235587, -8.325846) "
          />
        </g>
      </g>
    </g>
  </svg>
)

export const FullScreenExpandIcon = () => (
  <svg
    width="24px"
    height="24px"
    viewBox="0 0 24 24"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
      <g>
        <rect
          stroke="#F0F0F0"
          fill="#FFFFFF"
          opacity="0.6"
          x="0.5"
          y="0.5"
          width="23"
          height="23"
          rx="2"
        />
        <path
          d="M10.5,18 L7.41,18 L11.5564466,13.8535534 C11.7517088,13.6582912 11.7517088,13.3417088 11.5564466,13.1464466 L10.8535534,12.4435534 C10.6582912,12.2482912 10.3417088,12.2482912 10.1464466,12.4435534 L6,16.59 L6,13.5 C6,13.2238576 5.77614237,13 5.5,13 L4.5,13 C4.22385763,13 4,13.2238576 4,13.5 L4,19.5 C4,19.7761424 4.22385763,20 4.5,20 L10.5,20 C10.7761424,20 11,19.7761424 11,19.5 L11,18.5 C11,18.2238576 10.7761424,18 10.5,18 Z M13.8535534,11.5564466 L18,7.41 L18,10.5 C18,10.7761424 18.2238576,11 18.5,11 L19.5,11 C19.7761424,11 20,10.7761424 20,10.5 L20,4.5 C20,4.22385763 19.7761424,4 19.5,4 L13.5,4 C13.2238576,4 13,4.22385763 13,4.5 L13,5.5 C13,5.77614237 13.2238576,6 13.5,6 L16.59,6 L12.4435534,10.1464466 C12.2482912,10.3417088 12.2482912,10.6582912 12.4435534,10.8535534 L13.1464466,11.5564466 C13.3417088,11.7517088 13.6582912,11.7517088 13.8535534,11.5564466 Z"
          fill="#333333"
          fillRule="nonzero"
        />
      </g>
    </g>
  </svg>
)

export const FullScreenCloseIcon = () => (
  <svg
    width="26px"
    height="26px"
    viewBox="0 0 26 26"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
      <g>
        <circle
          stroke="#F0F0F0"
          strokeWidth="1.18181818"
          fill="#FFFFFF"
          opacity="0.6"
          cx="13"
          cy="13"
          r="12.4090909"
        />
        <g transform="translate(7.000000, 7.000000)" fill="#333333">
          <rect
            transform="translate(6.000000, 6.000000) rotate(45.000000) translate(-6.000000, -6.000000) "
            x="5"
            y="-1"
            width="2"
            height="14"
            rx="1"
          />
          <rect
            transform="translate(6.000000, 6.000000) scale(-1, 1) rotate(45.000000) translate(-6.000000, -6.000000) "
            x="5"
            y="-1"
            width="2"
            height="14"
            rx="1"
          />
        </g>
      </g>
    </g>
  </svg>
)
